<template>
    <div class="ai-tab-bar" :id="id">
        <svg class="ai-tab-scroll-left" @click="scrollLeft" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 512 512">
            <path
                fill="none"
                stroke="currentColor"
                stroke-linecap="round"
                stroke-linejoin="round"
                stroke-width="12"
                d="M328 112L184 256l144 144"
            />
        </svg>

        <div class="ai-tab-bar-container" :id="containerID()">
            <div v-for="view in views" :key="view.viewId">
                <ai-tab-bar-item
                    :id="view.viewId"
                    :key="view.viewId"
                    :view="view"
                    :focusedTab="focusedTab"
                    @itemClick="onTabItemClick"
                    @closeItemClick="onCloseTabItemClick"
                />
                <dx-context-menu
                    :items="contextMenuItems"
                    :width="200"
                    :target="`#${view.viewId}`"
                    showEvent="dxcontextmenu"
                    @item-click="contextMenuItemClick"
                />
            </div>
        </div>
        <svg
            v-if="isRightScrollVisible"
            class="ai-tab-scroll-right"
            @click="scrollRight"
            xmlns="http://www.w3.org/2000/svg"
            viewBox="0 0 512 512"
        >
            <path
                fill="none"
                stroke="currentColor"
                stroke-linecap="round"
                stroke-linejoin="round"
                stroke-width="12"
                d="M184 112l144 144-144 144"
            />
        </svg>
    </div>
</template>

<script>
export default {
    name: 'tab-bar',
};
</script>

<script setup>
import { onMounted, ref, watch } from 'vue';
import DxContextMenu from 'devextreme-vue/context-menu';
import AiTabBarItem from './tab-bar-item.vue';
import { getFocusedTab, setFocusedTab } from '@/layouts/main-layout/components/navigation-bars-data';

onMounted(() => {
    focusedTab.value = getFocusedTab();
});

const props = defineProps({
    id: {
        type: String,
        default: '',
    },
    views: {
        type: Array,
        default: function () {
            return [];
        },
    },
});

const isRightScrollVisible = ref(true);
const focusedTab = ref();

watch(
    () => props.views,
    () => {
        focusedTab.value = getFocusedTab();
    }
);

const emit = defineEmits(['tabItemClick', 'closeTabItemClick', 'closeByContextMenu']);

const containerID = () => {
    return props.id + '-container';
};

const scrollLeft = async () => {
    const container = document.querySelector('#' + containerID());
    container.scrollLeft = container.scrollLeft - 150;
};

const scrollRight = () => {
    const container = document.querySelector('#' + containerID());
    container.scrollLeft = container.scrollLeft + 150;
    isScrolledIntoView();
};

const isScrolledIntoView = () => {
    const container = document.querySelector('#' + containerID());
    const tab_bar = document.querySelector('#' + props.id);
    return container.scrollWidth > tab_bar.offsetWidth;
};

const onTabItemClick = async item => {
    setFocusedTab(item);
    emit('tabItemClick', item);
    focusedTab.value = getFocusedTab();
};

const onCloseTabItemClick = async item => {
    emit('closeTabItemClick', item);
    focusedTab.value = getFocusedTab();
};

const contextMenuItemClick = ({ itemData }) => {
    emit('closeByContextMenu', itemData);
};

const contextMenuItems = [
    { text: 'Закрыть все вкладки', name: 'closeAll' },
    { text: 'Закрыть все вкладки кроме текущей', name: 'closeAllExceptCurrent' },
];
</script>

<style lang="scss">
.ai-tab-bar {
    margin-top: 5px;
    display: flex;
    flex-direction: row;
    flex-flow: nowrap;

    .ai-tab-scroll-left {
        height: 30px;
        width: 30px;
        padding-right: 10px;
    }

    .ai-tab-scroll-right {
        height: 30px;
        width: 30px;
        padding-left: 10px;
    }

    .ai-tab-bar-container {
        display: flex;
        flex-direction: row;
        overflow-x: scroll;
    }

    .ai-tab-bar-container::-webkit-scrollbar {
        display: none;
    }
}
</style>
